import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ExternalLink, Github, Terminal } from 'lucide-react';

const projects = [
  {
    title: "Xearox Portfolio",
    description: "Meine persönliche Webseite. Ein Experiment in Industrial Design und Web Development.",
    tags: ["React", "Tailwind", "Framer Motion"],
    status: "Live",
    link: "https://xearox.de"
  },
  {
    title: "Space-War",
    description: "Ein oldschool Browsergame. Tabellarisch und modern.",
    tags: ["Java", "React", "MySQL"],
    status: "In Arbeit",
    link: "https://space-war.com"
  },
  {
    title: "xQuickLaunch",
    description: "Eine moderne Desktop-Anwendung zum Verwalten von Verknüpfungen für Windows und Linux.",
    tags: ["Python", "CustomTkinter"],
    status: "Open Source",
    link: "https://github.com/xsoftwareforge/xQuickLaunch",
    github: "https://github.com/xsoftwareforge/xQuickLaunch"
  }
];

const Projects = () => {
  return (
    <section id="projects" className="py-24 bg-secondary/10 border-y border-border">
      <div className="container mx-auto px-4">

        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-4">
          <div>
            <h2 className="text-4xl md:text-5xl font-display font-bold mb-2">MEINE <span className="text-primary">PROJEKTE</span></h2>
            <p className="text-muted-foreground max-w-lg">
              Was ich baue, wenn ich nicht arbeite.
            </p>
          </div>
          <div className="flex items-center gap-2 font-mono text-xs text-muted-foreground bg-background px-3 py-1 border rounded-sm">
            <Terminal className="w-3 h-3" />
            <span>git fetch origin main</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <Card className="h-full flex flex-col bg-card border-border/50 hover:border-primary/50 transition-all duration-300 group">
                <CardHeader>
                  <div className="flex justify-between items-start mb-2">
                    <Badge variant={project.status === "Live" ? "default" : "secondary"} className="font-mono text-xs uppercase rounded-sm">
                      {project.status}
                    </Badge>
                    <Terminal className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors" />
                  </div>
                  <CardTitle className="font-display text-2xl tracking-wide">{project.title}</CardTitle>
                  <CardDescription className="text-muted-foreground/80 font-light">
                    {project.description}
                  </CardDescription>
                </CardHeader>
                <CardContent className="mt-auto">
                  <div className="flex flex-wrap gap-2 mb-4">
                    {project.tags.map(tag => (
                      <span key={tag} className="text-xs font-mono px-2 py-1 bg-secondary/30 text-secondary-foreground rounded-sm border border-white/5">
                        {tag}
                      </span>
                    ))}
                  </div>
                </CardContent>
                <CardFooter className="grid grid-cols-2 gap-3">
                  <Button variant="outline" className="w-full rounded-sm group-hover:bg-primary group-hover:text-white group-hover:border-primary transition-all" asChild>
                    <a href={project.link} target="_blank" rel="noopener noreferrer">
                      <ExternalLink className="w-4 h-4 mr-2" /> Ansehen
                    </a>
                  </Button>
                  {project.github && (
                    <Button variant="ghost" className="w-full rounded-sm" asChild>
                      <a href={project.github} target="_blank" rel="noopener noreferrer">
                        <Github className="w-4 h-4 mr-2" /> Code
                      </a>
                    </Button>
                  )}
                </CardFooter>
              </Card>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Projects;
